import React, { Component } from 'react';
import AccountService from '../services/AccountService';

import LogoVert from './SVG/LogoVert';

export default class SplashPage extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        window.zzResume = () => { };
        window.zzPause = () => { };
    }

    componentDidMount() {
        var self = this;
        var timeout = setTimeout(function () {
            self.props.changePage('login', true);
        }, 2000)
    }

    componentWillReceiveProps() { }

    render() {
        return (
            <div id="page-outer" className="splash-page-outer">
                <div className="login-logo-view-outer-outer">
                    <div className="splash-logo-container">
                        <LogoVert className="splash-logo" />
                    </div>
                </div>
            </div>
        );
    }
}
